import dayjs from 'utils/dayjs';

/**
 * Returns the list of presets for the custom period range picker. The key is the preset's name, and the valye is a [startDate, endDate] array
 * @param {Object} intl - react-intl object
 * @param {Number} year
 * @return {Object.<String, Moment[]>} an object with the 12 months and 4 quarters preset for the given year
 */
const getRangePickerPresets = (intl, year) => {
    const presets = [];
    // month presets
    let date = dayjs().year(year).startOf('year');
    for (let m = 0; m <= 11; m += 1) {
        date = date.month(m);
        const monthName = intl.formatDate(date, {
            month: 'short',
            year: '2-digit',
        });
        presets.push({ label: monthName, value: [date.clone().startOf('month'), date.clone().endOf('month')] });
    }
    // quarter presets
    date = dayjs().year(year).startOf('year');
    for (let q = 1; q <= 4; q += 1) {
        date = date.quarter(q);
        presets.push({ label: `Q${q}`, value: [date.clone().startOf('quarter'), date.clone().endOf('quarter')] });
    }
    return presets;
};

/**
 * Check if a date is in range of the start or end date of a period range
 * @param {Moment} date - date to check if in range
 * @param {String} rangeStart
 * @param {String} rangeEnd
 * @param {Number} maxPeriodLength - in months
 * @return {Boolean}
 */
const checkIfDateInRange = (date, rangeStart, rangeEnd, maxPeriodLength) => {
    // If no date selected yet, any date can be selected
    if (rangeStart === null && rangeEnd === null) {
        return true;
    }

    const isTooLate = rangeStart && date.isAfter(dayjs(rangeStart).add(maxPeriodLength, 'month'), 'day');
    const isTooEarly = rangeEnd && date.isBefore(dayjs(rangeEnd).subtract(maxPeriodLength, 'month'), 'day');
    return !isTooEarly && !isTooLate;
};

export { getRangePickerPresets, checkIfDateInRange };
